import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import type { Contractor } from "@/data/types";
import { ContractorService } from "@/services/contractor.service";

async function fetchContractors(): Promise<Contractor[]> {
  const contractors = await ContractorService.fetchContractors();
  return contractors ?? [];
}

export function useReactQueryContractors() {
  const {
    data: contractors = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: ["contractors"],
    queryFn: fetchContractors,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return {
    contractors,
    loading: isLoading,
    error,
  };
}
